<template>
  <div
    class="operation-report-list-timeline-select flex items-center row-gap-2 flex-wrap"
  >
    <div class="timeline-select-calendars flex items-center gap-2 flex-wrap">
      <operation-input-period-form
        class="timeline-select-start-date"
        :value.sync="dialogStartDate"
        dateFormat="Y/m/d"
        placeholder="2024/01/01"
      ></operation-input-period-form>
      <span>
        〜
      </span>
      <operation-input-period-form
        class="timeline-select-end-date"
        :value.sync="dialogEndDate"
        dateFormat="Y/m/d"
        placeholder="2024/01/01"
      ></operation-input-period-form>
    </div>

    <vs-button
      class="apply-button flex items-center flex-shrink-0"
      :color="AISEA_COLOR.BLUE"
      type="border"
      style="width: 60px; height: 44px; padding: 8px 15px;"
      @click="onClickApply"
    >
      <span class="aisea-text-14-400-blue">{{ applyText }}</span>
    </vs-button>
  </div>
</template>

<script>
import ColorMixin from "@/mixins/ColorMixin.js";
import OperationInputPeriodForm from "@/views/enterprise/addon/operation/components/DatePicker.vue";
import isObject from "lodash/isObject";
import isDate from "lodash/isDate";

export const EVENTS = {
  APPLY: "apply",
};

export default {
  name: "OperationReportListTimelineSelect",
  mixins: [ColorMixin],
  components: {
    OperationInputPeriodForm,
  },
  props: {
    applyText: {
      type: String,
      default() {
        return this.$t("Views.Operation.Report.Apply");
      },
    },
    initialSelectedTimeline: {
      type: Object, // { startDate: Date | null; endDate: Date | null; }
      default: () => ({
        startDate: null,
        endDate: null,
      }),
    },
  },
  data() {
    return {
      dialogStartDate: null,
      dialogEndDate: null,
    };
  },
  computed: {
    /**
     * 選択されたダイアログの開始日を返す
     *
     * @returns {Date|null} 選択されたダイアログの開始日 / 無効な日付の場合はnullを返す
     */
    selectedDialogStartDate() {
      if (!isDate(this.dialogStartDate)) return null;
      return this.dialogStartDate;
    },
    /**
     * 選択されたダイアログの終了日を返す
     * @returns {Date | null} 選択されたダイアログの終了日 / 終了日が日付ではない場合は、nullを返す
     */
    selectedDialogEndDate() {
      if (!isDate(this.dialogEndDate)) return null;
      return this.dialogEndDate;
    },
    selectedTimeline() {
      return {
        startDate: this.selectedDialogStartDate,
        endDate: this.selectedDialogEndDate,
      }; // { startDate: Date | null; endDate: Date | null;}
    },
  },
  methods: {
    onClickApply() {
      this.$emit(EVENTS.APPLY, this.selectedTimeline);
    },
    /**
     * 初期化時の日時選択の値として渡されたpropsをdataに設定する
     * @returns {void}
     */
    setInitialTimeline() {
      const ist = this.initialSelectedTimeline;
      if (!isObject(ist)) return;
      this.dialogStartDate = isDate(ist.startDate) ? ist.startDate : null;
      this.dialogEndDate = isDate(ist.endDate) ? ist.endDate : null;
    },
  },
  created() {
    this.setInitialTimeline();
  },
};
</script>
<style lang="scss" scoped>
.operation-report-list-timeline-select {
  column-gap: 22px;
}

.apply-button {
  ::v-deep .vs-button-backgroundx.vs-button--background {
    display: none; // ボタンクリックした時に、背景色が変わるのを防ぐ
  }
}
</style>
